import { VALIDATION_TYPES } from '../config/constants';
import uidMixin from './uid.mixin';

export default {
  mixins: [
    uidMixin,
  ],

  props: {
    /**
     * Validation object
     * @values Object: {type: "valid"|"invalid, messages: array}
     * */
    validation: {
      type: Object,
      default: null,
      required: false,
      validator(value) {
        const { type, messages } = value;

        if (!VALIDATION_TYPES.includes(type)) {
          return false;
        }

        return Array.isArray(messages);
      },
    },
    helpText: {
      type: String,
      default: '',
      required: false,
    },
    id: {
      type: String,
      default: null,
      required: false,
    },
  },

  computed: {
    cmpId() {
      if (this.id) {
        return this.id;
      }

      if (this.$attrs.id) {
        return this.$attrs.id;
      }

      return `dpcmp-${this._uid}`;
    },

    validationClass() {
      if (this.hasValidation) {
        return `is-${this.validation.type}`;
      }

      return '';
    },

    ariaDescribedBy() {
      if (!this.helpText) {
        return false;
      }

      const { id } = this;
      const helpId = id || this._uid;

      return `helpId-${helpId}`;
    },

    hasValidation() {
      if (!this.validation) {
        return null;
      }

      const hasValidationObject = Object.keys(this.validation).length > 0 && this.validation.constructor === Object;

      return !!hasValidationObject;
    },

    helpBlock() {
      if (this.hasValidation) {
        return null;
      }

      return this.helpText;
    },

    validationFeedbackText() {
      if (!this.hasValidation) {
        return null;
      }

      const { messages } = this.validation;

      if (messages.length === 0) {
        return null;
      }

      return messages[0];
    },

    validationFeedbackClass() {
      if (!this.hasValidation) {
        return null;
      }

      return `${this.validation.type}-feedback`;
    },

    hasLabel() {
      if (!this.label && !this.$slots.default) {
        return false;
      }

      return true;
    },
  },
};
